import React from "react";
import { Compass } from "lucide-react";
import { Button } from "@/components/ui/button";

export function EmptyState({
  title = "Nothing here yet",
  description = "Try adjusting your search or filters to discover what's happening.",
  actionLabel,
  onAction,
  icon: Icon = Compass,
  testId = "empty-state",
}) {
  return (
    <div
      data-testid={testId}
      className="flex flex-col items-center justify-center rounded-3xl border border-dashed border-border bg-secondary/40 px-6 py-20 text-center"
    >
      <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-2xl bg-brand/10 text-brand">
        <Icon className="h-7 w-7" />
      </div>
      <h3 className="font-heading text-xl font-bold tracking-tight text-foreground">
        {title}
      </h3>
      <p className="mt-2 max-w-md text-sm text-muted-foreground">{description}</p>
      {actionLabel && (
        <Button
          data-testid="empty-state-action"
          onClick={onAction}
          className="mt-6 rounded-full bg-brand px-6 hover:bg-brand-hover"
        >
          {actionLabel}
        </Button>
      )}
    </div>
  );
}

export default EmptyState;
